enum Gender {
	Male = 'male',
	Female = 'female',
}

export default Gender
